<template>
  <div class="switchBar">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="id" prop="feedbackId" />
      <el-table-column label="标题" prop="feedbackTitle" />
      <el-table-column label="描述" prop="feedbackDesc" />
      <el-table-column label="email" prop="feedbackEmail" />
      <el-table-column label="手机" prop="feedbackIphone" />
      <el-table-column label="结果" prop="feedbackResult" />
      <el-table-column label="状态">
        <template #default="{ row }">
          <el-tag
            size="large"
            :type="row.feedbackStatus == 0 ? 'warning' : 'success'"
            >{{ row.feedbackStatus == 0 ? "未处理" : "已处理" }}</el-tag
          >
        </template> </el-table-column
      >>
      <el-table-column label="创建时间" prop="createTime" />
      <el-table-column align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="default"
            :disabled="scope.row.feedbackStatus == 0 ? false : true"
            @click="handleEdit(scope.row)"
            >回复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="dialogVisible"
      width="500"
      draggable
      :show-close="false"
    >
      <el-input
        v-model="form.feedbackDesc"
        autosize
        type="textarea"
        placeholder="Please input"
      />
      <div style="margin: 20px 0" />
      <el-input
        v-model="form.feedbackResult"
        :autosize="{ minRows: 5 }"
        type="textarea"
        placeholder="请输入"
        maxlength="300"
        show-word-limit
      />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitReply"> 确定 </el-button>
        </div>
      </template>
    </el-dialog>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>

  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox, TabsPaneContext } from "element-plus";
import { Form } from "@/views/view";
export default defineComponent({
  name: "App",
  data(): any {
    return {
      currentPage: 1,
      total: 1,
      dialogImageUrl: "",
      dialogVisible: false,
      activeName: "first",
      tableData: [],
      status: 0,
      centerDialogVisible: false,
      form: {
        createTime: "",
        feedbackDesc: "",
        feedbackEmail: "",
        feedbackId: "",
        feedbackIphone: "",
        feedbackTitle: "",
        feedbackResult: "",
        feedbackStatus: 0,
        gameId: "",
      },
    };
  },
  components: {
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  mounted() {},
  created() {
    this.fetchFeedbackList(this.currentPage, this.status);
  },
  methods: {
    fetchFeedbackList(pageNum: number) {
      const pageSize = 10;
      this.dialogVisible = false;
      this.$store
        .dispatch("user/getFeedbackList", { pageNum, pageSize })
        .then((res: any) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err: any) => {
          ElMessage({
            message: err,
            type: "warning",
          });
        });
    },
    handleCurrentChange(val: number) {
      this.fetchFeedbackList(val, this.status);
    },
    handleEdit(row: Form) {
      this.dialogVisible = true;
      this.form = row;
      console.log(row);
    },
    handleClick(tab: TabsPaneContext) {
      this.status = tab.paneName === "first" ? 0 : 2;
      this.fetchFeedbackList(1, this.status);
    },
    quash(index: number, data: any) {
      this.updateGame(index, data.id);
    },
    updateGame(status: number, userId: string) {
      this.$store
        .dispatch("game/UpdateUserStatus", { status: status, userId: userId })
        .then((res: any) => {
          this.handleCurrentChange(this.currentPage);
        })
        .catch(() => {});
    },
    submitReply() {
      const params = {
        id: this.form.feedbackId,
        email: this.form.feedbackEmail,
        content: this.form.feedbackResult,
        question: this.form.feedbackTitle || "出发吧意见反馈",
      };

      this.$store
        .dispatch("user/replyFeedback", params)
        .then((res: any) => {
          this.fetchFeedbackList();
        })
        .catch((err: any) => {
          ElMessage({
            message: err || "反馈失败",
            type: "error",
          });
        });
    },
  },
});
</script>

<style lang="less" scoped>
.switchBar {
  width: 100%;
  height: auto;
}

.pagination {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
